import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import AsyncSelect from 'react-select/async'
import { useDispatch, useSelector } from 'react-redux'
import { useForm, Controller } from 'react-hook-form'
import LayoutSidebar from "../components/LayoutSidebar";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons'
import { selectDropdownOptions, selectDropdowns } from "../redux/dropdownSlice";
import { setNotification } from "../redux/notificationSlice";
import { generateErrorBody, handleErrorResponse } from "../helpers/errorHandling";
import { useRequest } from "../hooks/UseRequest";
import { reactSelectClassNames } from "../helpers/react-select-styles";
import { selectAuth } from '../redux/authSlice'
import Loading from "../components/Loading";
import { Link } from 'react-router-dom'
import { setModal } from "../redux/modalSlice";
import Papa from 'papaparse';
import { FormatISODateTime24HoursDB } from '../helpers/formatting'

export default function SendEmail({ type }) {
  const [saving, setSaving] = useState(false)
  const [templates, setTemplates] = useState(null);
  const [templateOptions, setTemplateOptions] = useState(null);
  const [loaded, setLoaded] = useState(false)
  const [selectedTemplate, setSelectedTemplate] = useState(false)
  const [selectedTemplateOption, setSelectedTemplateOption] = useState(false)
  const [selectedPromotionOption, setSelectedPromotionOption] = useState(false)
  const [selectedPromotionType, setSelectedPromotionType] = useState({ value: "none", label: "None" })
  const [selectedPromotionCodeOption, setSelectedPromotionCodeOption] = useState(false)
  const [isLoadingTemplate, setIsLoadingTemplate] = useState(false)
  const [isLoadingSampleFile, setIsLoadingSampleFile] = useState(false)
  const [file, setFile] = useState(null);
  const [promotionOptions, setPromotionOptions] = useState();
  const [promotionGroupOptions, setPromotionGroupOptions] = useState([]);
  const [promotionsByPromotionGroup, setPromotionsByPromotionGroup] = useState([]);
  const [selectedPromotionGroup, setSelectedPromotionGroup] = useState(false);

  const [emailFrom, setEmailFrom] = useState('');

  const [fileRows, setFileRows] = useState([]);
  const [fileValues, setFileValues] = useState([]);
  const [portfolioId, setPortfolioId] = useState(null);
  const auth = useSelector(selectAuth)
  const requests = useRequest()
  const dropdownOptions = useSelector(selectDropdownOptions);
  const promotionTypeOptions = dropdownOptions.filter((o) =>
    o.code_key === 'promotion_type_collectionpercentoffer' ||
    o.code_key === 'promotion_type_interestfreepayments' ||
    o.code_key === 'promotion_type_freshstart' ||
    o.code_key === 'promotion_type_interestfreeloan' ||
    o.code_key === 'promotion_type_freepayments').map((o) => (o.id));
  const { register, handleSubmit, control, setError, formState: { errors, isDirty }, watch } = useForm();
  const dispatch = useDispatch();

  const promotionTypeDropdown = [
    { value: "none", label: "None" },
    { value: "single", label: "Single Promotion" },
    { value: "group", label: "Promotion Group" },
  ]

  let portfolios = null
  let promotionCodes = null

  const dispatchError = () => {
    if (Object.keys(errors).length > 0) {
      const body = generateErrorBody(errors, [])
      dispatch(setNotification({ type: 'error', body: body }))
    }
  }
  const onSubmit = async (formData) => {
    setSaving(true);
    let formError = false;
    // Configure the API endpoint
    requests.setEndpoint(`${process.env.REACT_APP_API_DOMAIN}/create_manual_marketing_email`)

    try {
      if (!formData.schedule_date) {
        setError("schedule_date", { type: "manual" });
        formError = true;
      }
      if (!emailFrom || !/^([A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,})|([A-Za-z\s]+<([A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,})>)$/i.test(emailFrom)) {
        setError("from_email_address", { type: "manual" });
        formError = true;
      }

      if (file === null) {
        setError("file", { type: "manual" });
        formError = true;
      }
      if (selectedPromotionType.value === 'single') {
        if (!selectedPromotionOption) {
          setError("promotion_id", { type: "manual" });
          formError = true;
        } else if (!selectedPromotionCodeOption) {
          setError("promotion_code", { type: "manual" });
          formError = true;
        }
      }

      if (selectedPromotionType.value === 'group') {
        if (!formData.promotion_expiration_date) {
          setError("promotion_expiration_date", { type: "manual" });
          formError = true;
        } else if (formData.schedule_date >= formData.promotion_expiration_date) {
          setError("promotion_expiration_date", { type: "manual", message: "Promotion Expiration Date at must be after email schedule date" });
          formError = true;
        }

        if (!selectedPromotionGroup) {
          setError("promotion_group_id", { type: "manual" });
          formError = true;
        }

        if (formData.promotion_schedule_date && formData.promotion_schedule_date > formData.schedule_date) {
          setError("promotion_schedule_date", { type: "manual", message: "Promotion available at must be before email schedule date" });
          formError = true;
        }
      }

      if (formError === true) {
        setSaving(false)
        dispatchError()
        return
      }

      // Initialize the request payload
      let body = {
        template_id: selectedTemplate.id,
        schedule_date: formData.schedule_date,
        from_email_address: emailFrom,
      }

      if (selectedPromotionType.value === 'single') {
        body["promotion_code_id"] = selectedPromotionCodeOption?.id
      } else if (selectedPromotionType.value === 'group') {
        body['promotion_group_id'] = selectedPromotionGroup?.value
        body['promotion_schedule_date'] = formData.promotion_schedule_date ? formData.promotion_schedule_date : null
        body['promotion_expiration_date'] = formData.promotion_expiration_date ? formData.promotion_expiration_date : null
      }

      // Make the API request
      const response = await requests.modify(body, file)

      // If the operation was successful, execute the success callback and reset the form
      if (response.status === 200 || response.status === 201) {
        setSaving(false)
        let title = '';
        let successMessage = '';

        if (response.data.queue_bulk_email_jobs?.id) {
          setFile(null)
          setSelectedTemplateOption(false)
          setSelectedTemplate(false)
          setSelectedPromotionOption(false)
          setSelectedPromotionCodeOption(false)
          setSelectedPromotionGroup(false)
          setSelectedPromotionType({ value: "none", label: "None" })

          successMessage = (
            <>
              <h3>The email job has been successfully queued for processing. Here is the summary:</h3>
              {/* eslint-disable-next-line react/no-unescaped-entities */}
              <p className={'has-text-success-dark ml-5 mt-2'}>Your list had {response.data.eligible_customer_num} customer id(s). This number does not reflect any customers on the suppression list or that shouldn't get a promotion.</p>
              {response.data.ineligible_customer_ids.length > 0 ? (
                  <>
                    <p className={'has-text-danger ml-5 mt-1'}>{response.data.ineligible_customer_ids.length} {response.data.ineligible_customer_ids.length == 1 ? 'customer is' : 'customers are'} not eligible for send email</p>
                    <table className="table is-striped is-narrow is-bordered is-hoverable ml-5 mt-3 is-info">
                      <thead>
                        <tr><th>customer_id</th><th>Error Message</th></tr>
                      </thead>
                      <tbody>
                        {response.data.ineligible_customer_ids.map((o) => (
                          <tr><td>{o.customer_id}</td><td>{o.error_message}</td></tr>
                        ))}
                      </tbody>
                    </table>
                  </>
                )
                : ''}
              <h3 className={'mt-2'}>You can track the progress of this job in <a href={'/queue_bulk_email_job'}> Queue Bulk Email Job</a></h3>
            </>
          )

          title = `Queue Email Job #${response.data.queue_bulk_email_jobs.id} Created Successfully`;
        } else {
          successMessage = (
            <>
              <h3>No email job has been queued for processing. Here is the summary:</h3>
              <p className={'has-text-success-dark ml-5 mt-2'}>{response.data.eligible_customer_num} {response.data.eligible_customer_num == 1 ? 'customer' : 'customers'} were added to the queue.</p>
              {response.data.ineligible_customer_ids.length > 0 ? (
                  <>
                    <p className={'has-text-danger ml-5 mt-1'}>{response.data.ineligible_customer_ids.length} {response.data.ineligible_customer_ids.length == 1 ? 'customer is' : 'customers are'} not eligible for send email</p>
                    <table className="table is-striped is-narrow is-bordered is-hoverable ml-5 mt-3 is-info">
                      <thead>
                        <tr><th>customer_id</th><th>Error Message</th></tr>
                      </thead>
                      <tbody>
                        {response.data.ineligible_customer_ids.map((o) => (
                          <tr><td>{o.customer_id}</td><td>{o.error_message}</td></tr>
                        ))}
                      </tbody>
                    </table>
                  </>
                )
                : ''}
            </>
          )

          title = 'Queue Email Job'
        }
         dispatch(
            setModal({
              is_active: true,
              type: 'alert_modal',
              options: { title: title, description: successMessage }
            })
          )
      } else {
        // If the operation was not successful, show an error notification
        setSaving(false)
        dispatch(setNotification({ type: 'error', body: `Error: ${response.status}` }))
      }
    } catch (error) {
      // If an exception occurs, reset the saving state and show an error notification
      setSaving(false)
      const errorMessage = error?.response?.data?.message ?? error?.response?.data?.messageExtreme
      dispatch(setNotification({ type: 'error', body: errorMessage }))
    }
  }

  useEffect(() => {
    if (!auth.fromPageChange) { return }
    if (auth.accessToken) {
      getTemplateOptions();
      setLoaded(true);
    }
  }, [auth.accessToken, promotionOptions])

  useEffect(() => {
    if (portfolioId) {
      setTemplateOptions(templates.filter((o) => o.portfolio_id === portfolioId))
      setSelectedTemplateOption(false)
      setSelectedTemplate(false)
      setSelectedPromotionOption(false)
      setSelectedPromotionCodeOption(false)
      loadPromotionOptions();
      loadPromotionGroups();
      setSelectedPromotionGroup(false)
      setSelectedPromotionType({ value: "none", label: "None" })
    }
  }, [portfolioId])

  useEffect(() => {
    if (selectedPromotionType?.value !== 'single') {
      setSelectedPromotionOption(false)
      setSelectedPromotionCodeOption(false)
    }
    if (selectedPromotionType?.value !== 'group') {
      setSelectedPromotionGroup(false)
    }
  }, [selectedPromotionType])

  const getTemplateOptions = async () => {
    requests.setEndpoint(`${process.env.REACT_APP_API_DOMAIN}/template_manual_marketing`)
    try {
      const response = await requests.get()
      if (response.status === 200 || response.status === 201) {
        setTemplates(response.data)
      } else {
        dispatch(setNotification({ type: 'error', body: `Error: ${response.status}` }))
      }
    } catch (error) {
      handleErrorResponse(error.response?.data?.errors, setError)
    }
  }

  const getTemplate = async (templateOption) => {
    setSelectedTemplateOption(templateOption);
    setIsLoadingTemplate(true);
    setSelectedPromotionOption(false);
    setFile(null)
    requests.setEndpoint(`${process.env.REACT_APP_API_DOMAIN}/template/${templateOption.value}`)
    try {
      const response = await requests.get()
      if (response.status === 200 || response.status === 201) {
        setSelectedTemplate(response.data.data)
        setEmailFrom(response.data.data.email_from)
      } else {
        dispatch(setNotification({ type: 'error', body: `Error: ${response.status}` }))
      }
    } catch (error) {
      handleErrorResponse(error.response?.data?.errors, setError)
    }
    setIsLoadingTemplate(false);
  }

  const loadPortfolioOptions = async (inputValue) => {
    if (portfolios) {
      return portfolios
    }
    requests.setEndpoint(`${process.env.REACT_APP_API_DOMAIN}/portfolio`)
    portfolios = requests.get().then((response) => response.data.data).catch((e) => {
      return [];
    })
    return portfolios
  };

  const loadPromotionCodeOptions = async (inputValue) => {
    let currentDate = new Date();
    currentDate = currentDate.getFullYear() + '-' + String(currentDate.getMonth() + 1).padStart(2, '0') + '-' + String(currentDate.getDate()).padStart(2, '0');

    const filterQuery = {
      and: [
        { column: 'promotion_id', value: selectedPromotionOption.value, operator: '=' },
        {
          or: [
            { column: 'end_date', value: currentDate, operator: '>' },
            { column: 'end_date', value: null, operator: 'is' },
          ]
        }
      ],
    };
    requests.setEndpoint(`${process.env.REACT_APP_API_DOMAIN}/promotion_code?filters=${JSON.stringify(filterQuery)}`)
    promotionCodes = requests.get().then((response) => response.data.data)
    return promotionCodes
  };

  const loadPromotionOptions = async (inputValue) => {
    const filterQuery = {
      and: [
        { column: 'is_active', value: 1, operator: '=' },
        { column: 'promotion_type_dropdown_option_id', value: promotionTypeOptions, operator: 'in' }
      ]
    };

    requests.setEndpoint(`${process.env.REACT_APP_API_DOMAIN}/promotion?per_page=1000&filters=${JSON.stringify(filterQuery)}`)

    try {
      const response = await requests.get()
      if (response.status === 200 || response.status === 201) {
        setPromotionOptions(response.data.data.filter((o) =>
          o.portfolio_id === portfolioId ||
          o.portfolio_id === null).map((o) => ({ value: o.id, label: o.name })))
      } else {
        dispatch(setNotification({ type: 'error', body: `Error-12: ${response.status}` }))
      }
    } catch (error) {
      handleErrorResponse(error.response?.data?.errors, setError)
    }
  };

  const loadPromotionGroups = async () => {
    const filterQuery = {
      and: [
        { column: 'portfolio_id', value: portfolioId, operator: '=' },
      ]
    };

    requests.setEndpoint(`${process.env.REACT_APP_API_DOMAIN}/promotion_group?per_page=1000&filters=${JSON.stringify(filterQuery)}`)

    try {
      const response = await requests.get()
      if (response.status === 200 || response.status === 201) {
        setPromotionGroupOptions(response.data.data.map((o) => ({ value: o.id, label: o.name })))
        setPromotionsByPromotionGroup(response.data.data.reduce((acc, obj) => {
          acc[obj.id] = obj.promotions;
          return acc;
        }, []))
      } else {
        dispatch(setNotification({ type: 'error', body: `Error-12: ${response.status}` }))
      }
    } catch (error) {
      handleErrorResponse(error.response?.data?.errors, setError)
    }
  };

  const handlePreviewTemplateClick = () => {
    dispatch(
      setModal({
        is_active: true,
        type: 'preview_template',
        options: { templateName: selectedTemplate.name, templateBody: selectedTemplate.body, record: selectedTemplate }
      })
    )
  }

  const handleGetSampleFileClick = async () => {
    setIsLoadingSampleFile(true)
    try {
      let endpoint = `${process.env.REACT_APP_API_DOMAIN}/download_sample_file/manual_marketing_customer_list.csv`;
      requests.setEndpoint(endpoint)
      const response = await requests.get()
      if (response.data.success) {
        window.open(response.data.data.url, "_blank")
      } else {
        dispatch(setNotification({ type: 'error', body: 'Failed to get download file!' }))
      }
      setIsLoadingSampleFile(false)
    } catch (error) {
      dispatch(setNotification({ type: 'error', body: 'Failed to get download file!' }))
    }
  }

  // Used for Non System Dropdowns
  const parseLabel = ((field) => {
    let option = field.name;
    if (field.label) {
      option = field.label;
    }
    return option
  })

  return (
    <LayoutSidebar
      id={false}
      contentTitle={"Send Emails"}
      content={loaded ? (
        <div className="container is-fluid pr-0">
          <form onSubmit={handleSubmit(onSubmit)} className="form lox-form mt-3" id="send_email_form">
            <div className="field is-horizontal">
              <label className={`dmc-modal-label`} htmlFor="portfolio_id">Portfolio:</label>
              <div className="control" style={{ width: '500px' }}>
                <Controller
                  name="portfolio_id"
                  control={control}
                  render={({ field: { onChange } }) => (
                    <AsyncSelect
                      name="portfolio_id"
                      cacheOptions
                      isSearchable={false}
                      defaultOptions
                      isDisabled={!templates}
                      loadOptions={loadPortfolioOptions}
                      getOptionLabel={(e) => parseLabel(e)}
                      getOptionValue={(e) => parseLabel(e)}
                      classNames={reactSelectClassNames()}
                      onChange={(val) => {
                        setPortfolioId(val?.id || null)
                        onChange(val?.id || null)
                      }}
                    />
                  )}
                />
              </div>
            </div>
            <div className="field is-horizontal mt-5">
              <label className={`dmc-modal-label`} htmlFor="template_id">Template:</label>
              <div className="control" style={{ width: '500px' }}>
                <Controller
                  name="template_id"
                  control={control}
                  render={({ field }) => (
                    <Select
                      name="template_id"
                      {...field}
                      classNames={reactSelectClassNames()}
                      value={selectedTemplateOption}
                      options={templateOptions}
                      isSearchable
                      isDisabled={!(portfolioId ?? false)}
                      onChange={(val) => {
                        getTemplate(val)
                      }}
                      styles={{ container: (base) => ({ ...base, width: '100%' }), menu: ({ ...css }) => ({ ...css, width: 'max-content' }) }}
                    />
                  )}
                />
              </div>
              {selectedTemplate && !isLoadingTemplate && (
                <button
                  type="button"
                  className="button has-background-primary has-text-white is-small ml-2"
                  onClick={handlePreviewTemplateClick}
                >
                  <span className="mx-3">
                      Preview Template
                  </span>
                </button>
              )}
              {selectedTemplateOption && isLoadingTemplate && (
                <Loading size="is-size-5" />
              )}
            </div>
            {selectedTemplate && !isLoadingTemplate && (
              <>
                <div className="field is-horizontal mt-5">
                  <label className={`dmc-modal-label`} htmlFor="portfolio_id">Subject:</label>
                  <div className="control" style={{ width: '500px' }}>
                    {selectedTemplate.subject}
                  </div>
                </div>
                <div className="field is-horizontal mt-5">
                  <label className={`dmc-modal-label`} htmlFor="schedule_date">Scheduled Date/Time:</label>
                  <div className="control" style={{ width: '500px' }}>
                    <Controller
                      name="schedule_date"
                      control={control}
                      render={({ field: { onChange } }) => (
                        <input
                          name="schedule_date"
                          className="input is-small"
                          type="datetime-local"
                          min={new Date().toISOString()}
                          form="send_email_form"
                          {...register('schedule_date')}
                        />
                      )}
                    />
                    <p className="has-text-danger is-size-7 lox-capitalize-first-letter">
                      {errors.schedule_date &&
                        <span>{errors.schedule_date.message ? errors.schedule_date.message : "Schedule Date is required"}</span>}
                    </p>
                  </div>
                </div>
                <div className="field is-horizontal mt-5">
                  <label className={`dmc-modal-label`} htmlFor="from_email_address">Email From:</label>
                  <div className="control" style={{ width: '500px' }}>
                    <Controller
                      name="from_email_address"
                      control={control}
                      render={({ field }) => (
                        <input
                          {...field}
                          name="from_email_address"
                          className="input is-small"
                          type="text"
                          value={emailFrom}
                          onChange={(event) => setEmailFrom(event.target.value)}
                        />
                      )}
                    />
                    <p className="has-text-danger is-size-7 lox-capitalize-first-letter">
                      {errors.from_email_address &&
                        <span>{errors.from_email_address.message ? errors.from_email_address.message : "Email From is required and must be valid email"}</span>}
                    </p>
                  </div>
                </div>
                <div className="field is-horizontal mt-5">
                  <label className={`dmc-modal-label`} htmlFor="portfolio_id">List:</label>
                  <div className="control" style={{ width: '500px' }}>
                    <Controller
                      control={control}
                      name="file"
                      render={({ field: { value, onChange, ...field } }) => {
                        return (
                          <input
                            {...field}
                            value={value?.fileName}
                            accept=".csv"
                            onChange={(event) => {
                              onChange(event.target.files[0]);
                              setFile(event.target.files[0]);
                              const fileParse = event.target.files[0];
                              Papa.parse(fileParse, {
                                header: true,
                                complete: (results) => {
                                  const rowsArray = [];
                                  const valuesArray = [];

                                  // Iterating data to get column name and their values
                                  results?.data?.map((d) => {
                                    rowsArray.push(Object.keys(d));
                                    valuesArray.push(Object.values(d));
                                  });
                                  setFileRows(rowsArray[0]);
                                  setFileValues(valuesArray);
                                },
                                error: (err) => {
                                  console.log(err);
                                },
                              });
                            }}
                            type="file"
                          />
                        );
                      }}
                    />
                    <p className="has-text-danger is-size-7 lox-capitalize-first-letter">
                      {errors.file && <span>{errors.file.message ? errors.file.message : "File is required"}</span>}
                    </p>
                    <Link
                      className="mt-2"
                      onClick={handleGetSampleFileClick}
                    >
                      Sample File
                    </Link>
                    {isLoadingSampleFile && (<Loading noWrapper size="is-size-5" />)}
                  </div>
                </div>
                {file && (
                  <div className="field is-horizontal">
                    <label className={`dmc-modal-label`}>File Review:</label>
                    <div
                      className="control lox-has-border-top"
                      style={{ width: '800px', maxHeight: '200px', overflow: 'auto' }}
                    >
                      <table className={'table is-striped is-narrow is-bordered is-hoverable is-fullwidth is-info'}>
                        <thead>
                        <tr>
                          {fileRows?.map((rows) => {
                            return <th>{rows}</th>;
                          })}
                        </tr>
                        </thead>
                        <tbody>
                        {fileValues?.map((value) => {
                          return (
                            <tr>
                              {value.map((val) => {
                                return <td>{val}</td>;
                              })}
                            </tr>
                          );
                        })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}

                <div className="field is-horizontal mt-5">
                  <label className={`dmc-modal-label`} htmlFor="promotion_type">Promotion Type:</label>
                  <div className="control" style={{ width: '500px' }}>
                    <Controller
                      name="promotion_type"
                      control={control}
                      render={({ field }) => (
                        <Select
                          name="promotion_type"
                          {...field}
                          classNames={reactSelectClassNames()}
                          options={promotionTypeDropdown}
                          isSearchable
                          value={selectedPromotionType}
                          isClearable
                          onChange={(val) => {
                            setSelectedPromotionType(val)
                            setSelectedPromotionCodeOption(false)
                            setSelectedPromotionOption(false)
                          }}
                          styles={{
                            container: (base) => ({ ...base, width: '100%' }),
                            menu: ({ ...css }) => ({ ...css, width: 'max-content' })
                          }}
                        />
                      )}
                    />
                  </div>
                </div>

                {selectedPromotionType?.value === 'single' && (
                  <>
                    <div className="field is-horizontal mt-5">
                      <label className={`dmc-modal-label`} htmlFor="promotion_id">Promotion:</label>
                      <div className="control" style={{ width: '500px' }}>
                        <Controller
                          name="promotion_id"
                          control={control}
                          render={({ field }) => (
                            <Select
                              name="promotion_id"
                              {...field}
                              classNames={reactSelectClassNames()}
                              options={promotionOptions}
                              isSearchable
                              value={selectedPromotionOption}
                              isClearable
                              onChange={(val) => {
                                setSelectedPromotionOption(val)
                                setSelectedPromotionCodeOption(false)
                              }}
                              styles={{
                                container: (base) => ({ ...base, width: '100%' }),
                                menu: ({ ...css }) => ({ ...css, width: 'max-content' }),
                              }}
                            />
                          )}
                        />
                        <p className="has-text-danger is-size-7 lox-capitalize-first-letter">
                          {errors.promotion_id &&
                            <span>{errors.promotion_id.message ? errors.promotion_id.message : 'Promotion is required'}</span>}
                        </p>
                      </div>
                    </div>
                    {selectedPromotionOption && (
                      <div className="field is-horizontal mt-5">
                        <label className={`dmc-modal-label`} htmlFor="portfolio_id">Promotion Code:</label>
                        <div className="control" style={{ width: '500px' }}>
                          <Controller
                            name="promotion_code"
                            control={control}
                            render={({ field: { onChange } }) => (
                              <AsyncSelect
                                name="promotion_code"
                                key={selectedPromotionOption.value}
                                cacheOptions
                                isSearchable={false}
                                defaultOptions
                                isClearable
                                loadOptions={loadPromotionCodeOptions}
                                getOptionLabel={(e) => parseLabel(e)}
                                getOptionValue={(e) => parseLabel(e)}
                                classNames={reactSelectClassNames()}
                                value={selectedPromotionCodeOption}
                                onChange={(val) => {
                                  onChange(val?.id || null)
                                  setSelectedPromotionCodeOption(val)
                                }}
                              />
                            )}
                          />
                          <p className="has-text-danger is-size-7 lox-capitalize-first-letter">
                            {errors.promotion_code &&
                              <span>{errors.promotion_code.message ? errors.promotion_code.message : "Promotion Code is required"}</span>}
                          </p>
                          <Link
                            target="_blank"
                            to="/promotion_code_customer"
                          >
                            Create New Promotion Code
                            <FontAwesomeIcon icon={faArrowUpRightFromSquare} className="is-size-12 ml-1" />
                          </Link>
                        </div>
                      </div>
                    )}
                  </>
                )}

                {selectedPromotionType?.value === 'group' && (
                  <>
                    <div className="field is-horizontal mt-5">
                      <label className={`dmc-modal-label`} htmlFor="portfolio_id">Promotion Group:</label>
                      <div className="control" style={{ width: '500px' }}>
                        <Controller
                          name="promotion_group_id"
                          control={control}
                          render={({ field }) => (
                            <Select
                              name="promotion_group_id"
                              {...field}
                              classNames={reactSelectClassNames()}
                              options={promotionGroupOptions}
                              isSearchable
                              value={selectedPromotionGroup}
                              isClearable
                              onChange={(val) => {
                                setSelectedPromotionGroup(val)
                              }}
                              styles={{
                                container: (base) => ({ ...base, width: '100%' }),
                                menu: ({ ...css }) => ({ ...css, width: 'max-content' }),
                              }}
                            />
                          )}
                        />
                        <p className="has-text-danger is-size-7 lox-capitalize-first-letter">
                          {errors.promotion_group_id &&
                            <span>{errors.promotion_group_id.message ? errors.promotion_group_id.message : 'Promotion Group is required'}</span>}
                        </p>
                      </div>
                    </div>
                    {selectedPromotionGroup && (
                      <div className="field is-horizontal mt-5">
                        <label className={`dmc-modal-label`} htmlFor="portfolio_id"></label>
                        <div style={{ width: '500px' }}>
                          <div><strong>Included Promotions:</strong></div>
                          {
                            promotionsByPromotionGroup[selectedPromotionGroup.value] && (
                              promotionsByPromotionGroup[selectedPromotionGroup.value].map((o) => {
                                return (
                                      <div key={`promotion_${o.id}`} className="pl-1">
                                        <span className="is-size-4">•</span> {o.name}
                                      </div>
                                )
                              })
                            )
                          }
                        </div>

                      </div>
                    )}

                    <div className="field is-horizontal mt-5">
                      <label className={`dmc-modal-label`} htmlFor="promotion_schedule_date">Promotion Activates At:</label>
                      <div className="control" style={{ width: '500px' }}>
                        <Controller
                          name="promotion_schedule_date"
                          control={control}
                          render={({ field: { onChange } }) => (
                            <input
                              name="promotion_schedule_date"
                              className="input is-small"
                              type="datetime-local"
                              min={FormatISODateTime24HoursDB(new Date().toISOString())}
                              form="send_email_form"
                              {...register('promotion_schedule_date')}
                            />
                          )}
                        />
                        <p className="has-text-danger is-size-7 lox-capitalize-first-letter">
                          {errors.promotion_schedule_date &&
                            <span>{errors.promotion_schedule_date.message ? errors.promotion_schedule_date.message : "Schedule Date is required"}</span>}
                        </p>
                      </div>
                    </div>

                    <div className="field is-horizontal mt-5">
                      <label className={`dmc-modal-label`} htmlFor="promotion_expiration_date">Promotion Expiration Date:</label>
                      <div className="control" style={{ width: '500px' }}>
                        <Controller
                          name="promotion_expiration_date"
                          control={control}
                          render={({ field: { onChange } }) => (
                            <input
                              name="promotion_expiration_date"
                              className="input is-small"
                              type="datetime-local"
                              min={FormatISODateTime24HoursDB(new Date().toISOString())}
                              form="send_email_form"
                              {...register('promotion_expiration_date')}
                            />
                          )}
                        />
                        <p className="has-text-danger is-size-7 lox-capitalize-first-letter">
                          {errors.promotion_expiration_date &&
                            <span>{errors.promotion_expiration_date.message ? errors.promotion_expiration_date.message : "Promotion Expiration is required"}</span>}
                        </p>
                      </div>
                    </div>
                  </>
                )}

                <div className="field is-horizontal mt-5">
                  <button
                    type="submit"
                    className="button is-link has-text-white is-small ml-2"
                    disabled={saving && 'disabled'}
                  >
                  <span className="mx-3">
                      {saving ? 'Submitting' : 'Send Email'}
                  </span>
                  </button>
                </div>
              </>
            )}
          </form>
        </div>
      ) : <Loading />}
      dashlets={false}
    />
  )
}
